import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PeoplePhoneNumberPopoverProps as Props } from './types';
import { Divider, Stack, Typography } from '@mui/material';
import { Icon } from '@aibees/shared/components';
import { PersonPhoneNumber } from '@aibees/elephant/components';

export const PeoplePhoneNumberPopover = memo(({ className, data }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('PeoplePhoneNumberPopover', className)}
      sx={SX.root}
    >
      <Stack direction="row" alignItems="center" gap={0.5} p={1}>
        <Icon name="address-book" size={18} color="primary.500" />
        <Typography variant="body3" fontWeight={700} color="grey.700">
          Contact Details
        </Typography>
      </Stack>
      <Divider />
      <Stack p={1}>
        <PersonPhoneNumber data={data} isPopoverVariant />
      </Stack>
    </Styled.Wrapper>
  );
});

PeoplePhoneNumberPopover.displayName = 'PeoplePhoneNumberPopover';
